import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'

import { check_permission } from './acl'

import ApplicantInfoGeneral from '@/views/applicantInfo/ApplicantInfoGeneral.vue'
import ApplicantInfoSchool from '@/views/applicantInfo/ApplicantInfoSchool.vue'
import ApplicantInfoUniversity from '@/views/applicantInfo/ApplicantInfoUniversity.vue'
import ApplicantInfoMedical from '@/views/applicantInfo/ApplicantInfoMedical.vue'
import ApplicantInfoEngInter from '@/views/applicantInfo/ApplicantInfoEngInter.vue'
import ApplicantInfoConstraints from '@/views/applicantInfo/ApplicantInfoConstraints.vue'
import ApplicantInfoAddUndergraduate from '@/views/applicantInfo/ApplicantInfoAddUndergraduate.vue'
import RegisteredProgramList from '@/views/RegisteredProgramList.vue'
import Explore from '@/views/Explore.vue'
import UndergraduateAnnouncement from '@/views/announcement/undergraduate/Announcement.vue'
import UndergraduateAnnouncementTCAS from '@/views/announcement/undergraduate/AnnouncementTCAS.vue'
import UndergraduateAnnouncementTCASdetail from '@/views/announcement/undergraduate/AnnouncementTCASdetail.vue'
import UndergraduateAnnouncementInter from '@/views/announcement/undergraduate/AnnouncementInter.vue'
import UndergraduateAnnouncementCon from '@/views/announcement/undergraduate/AnnouncementCon.vue'
import UndergraduateAnnouncementPremium from '@/views/announcement/undergraduate/AnnouncementPremium.vue'
import UndergraduateAnnouncementSpecial from '@/views/announcement/undergraduate/AnnouncementSpecial.vue'
import GraduateAnnouncement from '@/views/announcement/graduate/Announcement.vue'
import GraduateAnnouncementMaster from '@/views/announcement/graduate/AnnouncementMaster.vue'
import GraduateAnnouncementDoctor from '@/views/announcement/graduate/AnnouncementDoctor.vue'
import GraduateAnnouncementInter from '@/views/announcement/graduate/AnnouncementInter.vue'
import GraduateAnnouncementFutureInnovators from '@/views/announcement/graduate/AnnouncementFutureInnovators.vue'
import GraduateAnnouncementFileDownload from '@/views/announcement/graduate/AnnouncementFileDownload.vue'

import ConfigYear from '@/views/configs/ConfigYear.vue'
import ConfigFacultyBankAccount from '@/views/configs/ConfigFacultyBankAccount.vue'
import ConfigRound from '@/views/configs/ConfigRound.vue'
import ConfigProject from '@/views/configs/ConfigProject.vue'
import ConfigProjectGroup from '@/views/configs/ConfigProjectGroup.vue'
import ConfigCurriculum from '@/views/configs/ConfigCurriculum.vue'
import ConfigCurriculumConstraint from '@/views/configs/ConfigCurriculumConstraint.vue'
import ConfigMasterRegCurriculum from '@/views/configs/ConfigMasterRegCurriculum.vue'
import ConfigFacultyOfficerMain from '@/views/configFacultyOfficer/Main.vue'
import ConfigCurriculumGatPat from '@/views/configs/ConfigCurriculumGatPat.vue'

import InfoExample from '@/views/InfoExample.vue'
import CreatePassword from '@/views/CreatePassword.vue'

import Questionnaire from '@/views/Questionnaire.vue'


import ApplicationKbankSlip from '@/views/payInSlip/ApplicationKbankSlip.vue'
import ApplicationScbSlip from '@/views/payInSlip/ApplicationScbSlip.vue'
import AssertionKbankSlip from '@/views/payInSlip/AssertionKbankSlip.vue'
import ApplicationPdfUndergraduate from '@/views/applicationPdf/Undergraduate.vue'
import ApplicationPdfGraduate from '@/views/applicationPdf/Graduate.vue'

import NumberOfApplicantsReport from '@/views/reports/NumberOfApplicantsReport.vue'
import NumberOfApplicantsPassedReport from '@/views/reports/NumberOfApplicantsPassedReport.vue'
import NumberOfApplicantsByOrderReport from '@/views/reports/NumberOfApplicantsByOrderReport.vue'
import ApplicantsReportList from '@/views/reports/ApplicantsReportList.vue'
import SelectDataToShow from '@/views/reports/SelectDataToShow.vue'
import MoveApplicant from '@/views/MoveApplicant.vue'
import GenStudentID from '@/views/GenStudentID.vue'
import NotPaidTuitionFee from '@/views/reports/NotPaidTuitionFee.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '',
        name: 'default',
        component: Explore,
        props: (route) => ({
            level: 1,
            ...route.params
        })
    },
    {
        path: '/',
        name: 'slash_default',
        component: Explore,
        props: (route) => ({
            level: 1,
            ...route.params
        })
    },
    // { path: '/explore', name: 'explore', component: Explore },
    {
        path: '/undergraduate/explore',
        name: 'undergraduate_explore',
        component: Explore,
        props: (route) => ({
            level: 1,
            ...route.params
        })
    },
    {
        path: '/master/explore',
        name: 'master_explore',
        component: Explore,
        props: (route) => ({
            level: 2,
            ...route.params
        })
    },
    {
        path: '/phd/explore',
        name: 'phd_explore',
        component: Explore,
        props: (route) => ({
            level: 3,
            ...route.params
        })
    },
    { path: '/undergraduate/announcement', name: 'undergraduate_announcement', component: UndergraduateAnnouncement },
    { path: '/undergraduate/announcement_tcas', name: 'undergraduate_announcement_tcas', component: UndergraduateAnnouncementTCAS },
    { path: '/undergraduate/announcement_tcas_detail/:round', name: 'undergraduate_announcement_tcas_detail', component: UndergraduateAnnouncementTCASdetail, props: true },
    { path: '/undergraduate/announcement_inter', name: 'undergraduate_announcement_inter', component: UndergraduateAnnouncementInter },
    { path: '/undergraduate/announcement_con', name: 'undergraduate_announcement_con', component: UndergraduateAnnouncementCon },
    { path: '/undergraduate/announcement_premium', name: 'undergraduate_announcement_premium', component: UndergraduateAnnouncementPremium },
    { path: '/undergraduate/announcement_special', name: 'undergraduate_announcement_special', component: UndergraduateAnnouncementSpecial },
    { path: '/graduate/announcement', name: 'graduate_announcement', component: GraduateAnnouncement },
    { path: '/graduate/announcement_master', name: 'graduate_announcement_master', component: GraduateAnnouncementMaster },
    { path: '/graduate/announcement_doctor', name: 'graduate_announcement_doctor', component: GraduateAnnouncementDoctor },
    { path: '/graduate/announcement_inter', name: 'graduate_announcement_inter', component: GraduateAnnouncementInter },
    { path: '/graduate/announcement_future_innovators', name: 'graduate_announcement_future_innovators', component: GraduateAnnouncementFutureInnovators },
    { path: '/graduate/announcement_file_download', name: 'graduate_announcement_file_download', component: GraduateAnnouncementFileDownload },

    { path: '/config_year', name: 'config_year', component: ConfigYear },
    { path: '/config_faculty_bank_account', name: 'config_faculty_bank_account', component: ConfigFacultyBankAccount },
    { path: '/config_round', name: 'config_round', component: ConfigRound },
    { path: '/config_project', name: 'config_project', component: ConfigProject },
    { path: '/config_project_group', name: 'config_project_group', component: ConfigProjectGroup },
    { path: '/config_curriculum', name: 'config_curriculum', component: ConfigCurriculum },
    { path: '/config_curriculum_constraint', name: 'config_curriculum_constraint', component: ConfigCurriculumConstraint },
    { path: '/config_master_reg_curriculum', name: 'config_master_reg_curriculum', component: ConfigMasterRegCurriculum },
    { path: '/config_faculty_officer_main', name: 'config_faculty_officer_main', component: ConfigFacultyOfficerMain },
    { path: '/config_curriculum_gat_pat', name: 'config_curriculum_gat_pat', component: ConfigCurriculumGatPat },
    

    { path: '/applicant_info_general', name: 'applicant_info_general', component: ApplicantInfoGeneral },
    { path: '/applicant_info_school', name: 'applicant_info_school', component: ApplicantInfoSchool },
    { path: '/applicant_info_university', name: 'applicant_info_university', component: ApplicantInfoUniversity },
    { path: '/applicant_info_medicine', name: 'applicant_info_medicine', component: ApplicantInfoMedical },
    { path: '/applicant_info_eng_inter', name: 'applicant_info_eng_inter', component: ApplicantInfoEngInter },
    { path: '/applicant_info_constraints', name: 'applicant_info_constraints', component: ApplicantInfoConstraints },
    { path: '/applicant_info_additional_undergraduate', name: 'applicant_info_additional_undergraduate', component: ApplicantInfoAddUndergraduate },

    { path: '/registered_program_list', name: 'registered_program_list', component: RegisteredProgramList },
    { path: '/info_example', name: 'info_example', component: InfoExample },

    { path: '/create_password', name: 'create_password', component: CreatePassword },

    { path: '/questionnaire', name: 'questionnaire', component: Questionnaire },

    { path: '/application_kbank_slip/:register_id', name: 'application_kbank_slip', component: ApplicationKbankSlip, props: true },
    { path: '/application_scb_slip/:register_id', name: 'application_scb_slip', component: ApplicationScbSlip, props: true },
    { path: '/assertion_kbank_slip/:register_id', name: 'assertion_kbank_slip', component: AssertionKbankSlip, props: true },
    { path: '/application_pdf_undergraduate/:register_id', name: 'application_pdf_undergraduate', component: ApplicationPdfUndergraduate, props: true },
    { path: '/application_pdf_graduate/:register_id', name: 'application_pdf_graduate', component: ApplicationPdfGraduate, props: true },

    { path: '/number_of_applicants_report', name: 'number_of_applicants_report', component: NumberOfApplicantsReport },
    { path: '/number_of_applicants_passed_report', name: 'number_of_applicants_passed_report', component: NumberOfApplicantsPassedReport },
    { path: '/number_of_applicants_by_order_report', name: 'number_of_applicants_by_order_report', component: NumberOfApplicantsByOrderReport },
    // { path: '/applicants_report_list/:year_id/:round_id/:project_id/:master_reg_curriculum_id/:register_status_id/:refused', name: 'applicants_report_list', component: ApplicantsReportList, props: true },
    { path: '/applicants_report_list', name: 'applicants_report_list', component: ApplicantsReportList },
    { path: '/select_data_to_show', name: 'select_data_to_show', component: SelectDataToShow },
    { path: '/move_applicant', name: 'move_applicant', component: MoveApplicant },
    { path: '/gen_student_id', name: 'gen_student_id', component: GenStudentID },
    { path: '/not_paid_tuition_fee', name: 'not_paid_tuition_fee', component: NotPaidTuitionFee },
 ]

const router = new VueRouter({
    // mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
})

router.beforeEach((to, from, next) => {
    store.dispatch("auth/getUserInfo").then(() => {
        if (check_permission(to.name)) {
            next();
        }
        else {
            next('/undergraduate/explore');
        }
    });
});

export default router